<template>
    <v-dialog-old @hidden="cancel" :onCloseEsc="closeModal" ref="updateUrlDialog" class="glue" :special-styles="{ width: '1800px' }">
        <v-dialog-old @hidden="closeModal" :onCloseEsc="closeModal" ref="okDialog" class="glue">
            <strong>Заменено записей: {{ ok }}</strong>
            <footer><button @click="closeModal" class="green btn-norm" type="submit">OK</button></footer>
        </v-dialog-old>
        <fieldset>
            <legend>
                <span>Замена URL врача / клиники</span>
            </legend>
            <ValidationObserver v-slot="{ handleSubmit }" ref="urlChangeForm">
                <label>URL</label>
                <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|url"
                    vid="old"
                >
                    <input
                        v-model="url.old"
                        :class="{'hasError' : errors[0]}"
                        v-tooltip="{content: errors[0], template: tooltipStyle(),}"
                        @keyup.enter="handleSubmit(changeUrl)"
                    >
                </ValidationProvider>
                <label>Новый URL</label>
                <ValidationProvider
                    v-slot="{ errors }"
                    rules="required|url"
                    vid="new"
                >
                    <input
                        v-model="url.new"
                        :class="{'hasError' : errors[0]}"
                        v-tooltip="{content: errors[0], template: tooltipStyle(),}"
                        @keyup.enter="handleSubmit(changeUrl)"
                    >
                </ValidationProvider>
                <div class="mt-10">
                    <button @click.prevent="handleSubmit(changeUrl)" :disabled="processing">
                        <span v-if="!processing">Заменить</span>
                        <span v-else>обработка...</span>
                    </button>
                </div>
            </ValidationObserver>
        </fieldset>
    </v-dialog-old>
</template>

<script>
    export default {
        data: () => ({
            url: {
                old: null,
                new: null,
            },
            ok: null,
            processing: false,
        }),
        methods: {
            show() {
                this.$refs.updateUrlDialog.show()
            },
            cancel() {
                this.url.new = null
                this.url.old = null
                this.ok = null
            },
            closeModal() {
                this.cancel()
                this.$refs.updateUrlDialog.hide()
            },
            okModal() {
                this.$refs.okDialog.show()
            },
            changeUrl() {
                this.processing = true
                this.axios.post('/admin/settings/tools/updateUrl', {
                    'old_url': this.url.old,
                    'new_url': this.url.new,
                }).then((response) => {
                    if (response.status === 200) {
                        this.ok = response.data
                        this.okModal()
                    }
                    if (response.status === 400) {
                        if (response.data.message == 1) {
                            this.$refs.urlChangeForm.setErrors({
                                old: [response.data.errors]
                            });
                        }
                        if (response.data.message == 2) {
                            this.$refs.urlChangeForm.setErrors({
                                new: [response.data.errors]
                            });
                        }
                        if (response.data.message == 3) {
                            this.$refs.urlChangeForm.setErrors({
                                old: [response.data.errors],
                                new: [response.data.errors]
                            });
                        }
                    }
                    this.processing = false
                }).catch((error) => {
                    this.processing = false
                })
            },
            tooltipStyle() {
                return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`
            },
        },
    }
</script>
<style scoped>
    .mt-10 {
        margin-top: 10px;
    }
    .center {
        text-align: center;
    }
    .sc-pad-lr-20 {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
